import type { FaireProductEntity } from "../../entity_types/product";

export const p_6lbg51g67p: FaireProductEntity = {
  token: "p_6lbg51g67p",
  type: "product",
  name: "NERVE PAIN SALVE | 4 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/55740cb31be0edebccc7d4b7e46e7fb85425293cb9eacaac5a739d6dc485e390.jpeg",
  galleryImageUrls: [],
  priceDollars: 20.3,
  description:
    'This salve was specially formulated to serve our customer requests for relief from shooting, burning, or stabbing pain in their feet and legs. If you’re needing help with tingling and numbness or a recurring pins and needles feeling anywhere in your body, this soothing blend can help!\n\nTO USE: Apply to problem areas 2–3 times daily or as needed for pain.\n\nINGREDIENTS: RAW SHEA BUTTER, ORGANIC RAW UNREFINED COLD PRESSED COCONUT OIL, ORGANIC BEESWAX, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: PEPPERMINT, LAVENDER, FRANKINCENSE, BASIL, GERANIUM, EUCALYPTUS, CLOVE, WINTERGREEN.\n\n*These statements have not been evaluated by the Food & Drug Administration (FDA) and are not intended to diagnose, treat, or cure any disease.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\nDimension: 4 oz, 2.359" x 2.641" x 2.359".',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:05.572Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
